import variables from '../../styles/variables.module.scss';
import casebg from '../../assets/cases/detecht-casebg@2x-min.jpg';

export default {
  path: '/cases/detecht',
  color: variables.detecht,
  casebg,
  isWeb: false,
  isAndroid: false,
  case: null,
  title: 'Detecht',
  description: 'A safer bike ride',
  headline: 'iOS & Android application',
  sideHeadingSecond: 'Developed in React Native',
};
